import axiosInstance from './AxiosInstance';

export async function getFundTransfers(page = 1) {
    return axiosInstance.get('ledger/fund-transfers', { params: { page } });
}

export async function initiateFundTransfer(formData) {
    return axiosInstance.post('ledger/fund-transfers', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export async function confirmFundTransfer(fundTransferId, data) {
    return axiosInstance.post(`ledger/fund-transfers/${fundTransferId}/confirm`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export async function cancelFundTransfer(fundTransferId) {
    return axiosInstance.post(`ledger/fund-transfers/${fundTransferId}/cancel`);
}

export async function fetchFundTransferPreScreenshot(fundTransferId) {
    const response = await axiosInstance.get(`ledger/fund-transfers/${fundTransferId}/pre-screenshot`, { responseType: 'blob' });
    return response.data;
}

export async function fetchFundTransferPostScreenshot(fundTransferId) {
    const response = await axiosInstance.get(`ledger/fund-transfers/${fundTransferId}/post-screenshot`, { responseType: 'blob' });
    return response.data;
}
